export { default as CustomResearchNavLink } from './component';
